// MYS-7544: the impersonation context token (minted by GET /serviceprovider/:id?startImpersonation=true)
// is persisted with the store, so a stored one may belong to an earlier login in this browser.

// renew a little before the api would refuse it
const RENEW_BEFORE_EXPIRY_MS = 60 * 1000

export function decodeJwtPayload(token) {
	try {
		const payload = token?.split?.('.')?.[1]
		if (!payload) return null
		return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
	}
	catch (error) {
		return null
	}
}

// 'foreign': not minted for this login (other user or unreadable) - must not be sent
// 'expired': minted for this login but (about to be) expired - renew it
// 'valid'
export function checkImpersonationContext(impersonationToken, kcToken, now = Date.now()) {
	const payload = decodeJwtPayload(impersonationToken)
	const currentSub = decodeJwtPayload(kcToken)?.sub
	if (!payload?.sub || payload.sub !== currentSub) return { state: 'foreign' }
	if (!payload.exp || payload.exp * 1000 - now < RENEW_BEFORE_EXPIRY_MS) {
		return { state: 'expired', serviceProviderId: payload.serviceProviderId }
	}
	return { state: 'valid' }
}
